import { render, staticRenderFns } from "./MsdsModule.vue?vue&type=template&id=aae865cc&scoped=true"
import script from "./MsdsModule.vue?vue&type=script&lang=js"
export * from "./MsdsModule.vue?vue&type=script&lang=js"
import style0 from "./MsdsModule.vue?vue&type=style&index=0&id=aae865cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae865cc",
  null
  
)

export default component.exports